import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "antd";
import { LinkOutlined } from "@ant-design/icons";

const GooglePatentLink = props => {
  const { value } = props;
  const url = `https://www.google.com/patents/${value.replace(/-/g, "")}`;
  const styleIcon = {
    marginLeft: 4
  };
  return (
    <Tooltip title="View Google Patent">
      <a href={url} target="_blank" rel="noopener noreferrer nofollow" style={styleIcon}>
        <LinkOutlined />
      </a>
    </Tooltip>
  );
};

GooglePatentLink.propTypes = {
  value: PropTypes.string.isRequired
};

export default GooglePatentLink;
